import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { useIntersectionObserver } from './useIntersectionObserver.js';

const IntersectionObserverAnchor = ({ enabled = true, rootMargin = "400px", style, ...rest }) => {
  const ref = React__default.useRef(null);
  useIntersectionObserver({
    target: ref,
    enabled,
    rootMargin,
    ...rest
  });
  return /* @__PURE__ */ jsx("div", {
    "data-anchor": true,
    ref,
    style
  });
};

export { IntersectionObserverAnchor };
//# sourceMappingURL=IntersectionObserver.js.map
